import { processingStatuses } from 'consts/processingStatuses'
import { Message } from 'types/Api'

export const isMessageProcessing = (message?: Message) => {
  if (!message) return false

  return processingStatuses.includes(message.status) && !message.canceled
}
